import { bytesToString, ConditionChecker, parseTunnel, stringToBytes, traverse, TunnelUpdateTopic } from './natsnegcommon';
export class NatsViewerSession {
    constructor(peer, opts, neg, role = "v") {
        this.myState = { offers: {} };
        this.selectedHelper = "";
        this.role = "v";
        this.connectCalled = false;
        this.role = role;
        this.myState.offers[role] = {};
        this.opts = opts;
        this.neg = neg;
        this.peer = peer;
        this.checker = new ConditionChecker({
            "push initial offer": this.checkInitialOffer.bind(this),
            "resolve offers.h": this.checkHAccess.bind(this),
            "push offers.h+sdp": this.checkReportHSdp.bind(this),
            "resolve when offers.done": this.checkDone.bind(this),
        });
        this.collectOffer();
    }
    candsToJson(arr) {
        let ret = Array();
        arr.forEach(cand => {
            ret.push(cand.toJSON());
        });
        return ret;
    }
    get sid() {
        return this.myState.sid;
    }
    collectOffer() {
        this.opts.statusCb("Creating offer", null);
        this.opts.rtcLc.makeOffer().then((offer) => {
            this.opts.localDescription = offer;
            this.myState.offers[this.role].sdp = offer.sdp;
            console.log("cands on creation", this.opts.rtcLc, this.opts.rtcLc.collectedCandidates);
            this.myState.offers[this.role].candidates = this.candsToJson(this.opts.rtcLc.collectedCandidates);
            let tinyTimer = null;
            this.opts.rtcLc.onicecandidate = (ev) => {
                if (!ev.candidate) {
                    return;
                }
                console.log("cand", ev.candidate);
                this.myState.offers[this.role].candidates = this.candsToJson(this.opts.rtcLc.collectedCandidates);
                if (tinyTimer != null) {
                    clearTimeout(tinyTimer);
                }
                tinyTimer = setTimeout(() => {
                    this.pushUpdate();
                }, 200);
            };
            console.log(this.myState);
            this.checker.update();
        });
    }
    feedSid(sid, helper) {
        this.myState.sid = sid;
        this.selectedHelper = helper;
        this.checker.update();
    }
    feedPeer(peer) {
        this.peer = peer;
        this.checker.update();
    }
    checkInitialOffer(resolve) {
        var _a;
        if (!this.selectedHelper) {
            return;
        }
        let offers = (_a = this.myState) === null || _a === void 0 ? void 0 : _a.offers;
        if (!offers) {
            return;
        }
        let myOffer = offers[this.role];
        if (!myOffer || !myOffer.sdp) {
            return;
        }
        resolve();
        this.pushUpdate();
    }
    checkHAccess(resolve) {
        let hPath = traverse(this.state, "offers.h");
        if (!hPath) {
            return;
        }
        resolve();
        {
            this.myState.offers[this.role].hlocal = false;
            this.checker.update();
            // fetch(hPath).then((rsp) => {
            //     this.myState.offers![this.role].hlocal = (Math.trunc(rsp.status/100) == 2);
            //     this.checker.update()
            // }).catch(() => {
            //     this.myState.offers![this.role].hlocal = false
            //     this.checker.update()
            // })
        }
    }
    checkReportHSdp(resolve) {
        let hlocal = traverse(this.myState, `offers.${this.role}.hlocal`);
        let sdp = traverse(this.myState, `offers.${this.role}.sdp`);
        if (hlocal == undefined || !sdp) {
            return;
        }
        resolve();
        {
            this.pushUpdate();
        }
    }
    checkDone(resolve) {
        let done = traverse(this.state, "offers.done");
        if (!done) {
            return;
        }
        resolve();
        if (this.role == "v") {
            this.resolveStage1(this);
        }
        else {
            this.opts.onViewerReady(this);
        }
    }
    feedCandidate(cand, relatedHostCandidate) {
        this.myState.offers[this.role].lcand = relatedHostCandidate === null || relatedHostCandidate === void 0 ? void 0 : relatedHostCandidate.toJSON();
        this.myState.offers[this.role].rcand = cand.toJSON();
        this.checker.update();
    }
    updateCands() {
        if (!this.connectCalled) {
            return;
        }
        let negOffer = this.state.neg[this.role + "tou"];
        if (negOffer.candidates) {
            for (let i in negOffer.candidates) {
                this.opts.rtcLc.pc.addIceCandidate(negOffer.candidates[i]);
            }
        }
    }
    connect() {
        this.opts.rtcLc.pc.setLocalDescription(this.opts.localDescription);
        this.connectCalled = true;
        console.log("rtcLc", this.opts.rtcLc);
        //this.opts.rtcLc.pc.ontrack = this.opts.onTrack
        let negOffer = this.state.neg[this.role + "tou"];
        this.opts.rtcLc.pc.setRemoteDescription({ "type": "answer", "sdp": negOffer.sdp });
        this.updateCands();
        //this.opts.rtcLc.pc.addIceCandidate(this.state!.neg![this.role+"tou"].rcand!)
        //this.opts.rtcLc.pc.addIceCandidate(this.state!.neg![this.role+"tou"].lcand!)
    }
    close() {
        var _a, _b, _c;
        if (this.myState.offers && this.myState.offers.v) {
            this.myState.offers.v.closed = true;
            this.pushUpdate();
        }
        (_a = this.tunnelConn) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_c = (_b = this.opts.rtcLc) === null || _b === void 0 ? void 0 : _b.pc) === null || _c === void 0 ? void 0 : _c.close();
    }
    // DSZ: nats/sms/upd/vsend, Viewer send
    pushUpdate() {
        if (this.myState.offers != undefined &&
            this.myState.offers[this.role] != undefined &&
            this.myState.offers[this.role].hlocal) {
            this.myState.offers[this.role].ready = true;
        }
        return this.neg.nats.request(this.neg.buildMySms(TunnelUpdateTopic, "h", this.selectedHelper), stringToBytes(JSON.stringify(this.myState)), { timeout: 1000 });
    }
    doOfferNeg() {
        return new Promise((resolve, reject) => {
            this.resolveStage1 = resolve;
            let topic = "";
            if (this.role == "v") {
                topic = this.neg.buildTunnel("*", this.peer, this.neg.pubKey);
            }
            else {
                topic = this.neg.buildTunnel("*", this.neg.pubKey, this.peer);
            }
            console.log("New tunnel", topic);
            let sub = this.neg.nats.subscribe(topic);
            this.tunnelConn = sub;
            // DSZ: nats/tunnel/wi/rcv, Viewer receive
            // DSZ: nats/sms/upd/vrcv, Viewer receive
            sub.callback = (error, msg) => {
                let hdrs = parseTunnel(msg.subject);
                if (hdrs.helper != this.selectedHelper) {
                    return;
                }
                if (msg.data.length < 1) {
                    return;
                }
                // Starts with '{', assume JSON
                if (msg.data[0] == 123) {
                    this.state = JSON.parse(bytesToString(msg.data));
                    console.log("Tunnel state", this.state);
                    this.checker.update();
                    this.updateCands();
                }
                else if (msg.data.length >= 4) {
                    // DSZ: nats/tunnel/loc/wi/rcv, Receive
                    if (bytesToString(msg.data.slice(0, 4)) == "L001") {
                        let locJson = JSON.parse(bytesToString(msg.data.slice(4)));
                        if ((locJson === null || locJson === void 0 ? void 0 : locJson.loc) && this.onLocationUpdate) {
                            this.onLocationUpdate(locJson === null || locJson === void 0 ? void 0 : locJson.loc);
                        }
                        //console.log("Location", bytesToString(msg.data.slice(4)))
                    }
                }
            };
        });
    }
}
